import { useOnClickOutside } from "@/app/hooks/useOnClickOutside";
import clsx from "clsx";
import { ArrowDown, ChevronDown } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";

type Props = {
  value: number;
  index: number;
  onAgeChange: (age: number) => void;
  ageOptions: number[];
  label?: string;
};

export const CounterAge = ({
  value,
  index,
  ageOptions,
  label,
  onAgeChange,
}: Props) => {
  const t = useTranslations();
  const [isOpen, setOpen] = useState(false);
  const ref = useOnClickOutside<HTMLUListElement>(() => setOpen(false));

  return (
    <div className="relative py-2 pe-4 ps-8 border-b border-b-sleap-gray-400 dark:border-b-sleap-gray-600">
      <label
        htmlFor=""
        className="flex justify-between items-center font-medium"
        onClick={() => setOpen(true)}
      >
        <span className="flex flex-col">
          <span className="font-switzer font-semibold dark:text-white text-sleap-gray-950 text-base">
            {label == t("HomePageFlights.infants")
              ? t("HomePageFlights.infant")
              : t("HomePageFlights.child")}{" "}
            #{index + 1}
          </span>
          <span className="font-switzer font-medium dark:text-white text-sleap-gray-950 text-sm opacity-50">
            {t("HomePageFlights.pleaseSelectAge")}
          </span>
        </span>

        <div className="relative max-w-32 w-full border dark:border-sleap-gray-600 border-sleap-gray-400 rounded-full h-12 flex gap-x-2 items-center">
          <input
            value={value}
            name="age"
            className="py-2 ps-6 bg-lightwhite rounded-full font-medium w-[60px] text-end md:px-2 md:py-1 md:border-none font-switzer flex gap-1 text-black dark:text-white dark:bg-sleap-gray-950  focus-within:outline-none"
            readOnly
          />
          <div className="w-6 h-6 pe-4">
            <ChevronDown />
          </div>
        </div>
      </label>
      {isOpen && (
        <div className="absolute top-12 max-h-60 overflow-y-auto rounded-2xl md:absolute md:top-10 md:right-0 right-3 z-20 bg-lightwhite shadow-[0_-20px_25px_-5px_rgba(0,0,0,0.1)] border border-sleap-gray-400 dark:border-sleap-gray-650">
          <ul className="w-40 py-2 dark:bg-sleap-gray-950" ref={ref}>
            {ageOptions.map((age) => (
              <li key={age}>
                <button
                  type="button"
                  className={clsx(
                    "py-2.5 px-3.5 text-base font-medium font-inter text-sleap-gray-700 hover:bg-sleap-purple-300 rounded-none dark:text-white w-full",
                    value === age && "bg-sleap-purple-300 text-white"
                  )}
                  onClick={() => {
                    onAgeChange(age);
                    setOpen(false);
                  }}
                >
                  {age}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
